export enum CollectionName {
  CLIENT = "clients",
  USER = "users",
  PROBLEM = "fax",
}
